<template>
  <v-row
    justify="end"
    class="mr-0">
    <v-dialog
      dark
      persistent
      v-model="rejectItemDialog"
      max-width="1000px">
      <v-card
        :loading="loadingData">
        <v-card-title class="secondary">
          <span
            class="headline">
            {{ $t(translation + '.header') }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                icon
                v-bind="attrs"
                v-on="on"
                @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('tooltips.close') }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-on:submit.prevent>
              <!--Komentar-->
              <v-row>
                <v-col
                  cols="12">
                  <v-textarea
                    v-model="form.comment"
                    :label="$t(translation+'.comment')+'*'"
                    :rules="rules.required_length"
                    rows="3"
                    dark
                    outlined
                    required
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{ $t('required_fields') }}</small>
        </v-card-text>
        <v-card-actions>
          <div
            class="flex-grow-1">
          </div>
          <v-btn
            class="info mr-2"
            dark
            :loading="loading"
            @click="reject()"
          >
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  props: {
    rejectItemDialog: false,
    dataForModal: null
  },
  name: "RejectHelpRegistry",
  data() {
    return {
      translation: 'help_registries.reject',
      apiReject: '/api/help_registries/change_status/reject',
      loading: false,
      loadingData: false,
      form: {
        comment: '',
      },
      rules: {
        required_length: [
          v => (v !== '' && v.length > 1) || this.$t(this.translation + '.validation')
        ],
      },
    }
  },
  methods: {
    closeDialog() {
      this.form = {
        comment: ''
      }
      this.$refs.form.resetValidation()
      this.$emit('closeReject')
    },
    reject() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$swal
        .fire({
          title: this.$t(this.translation + '.message_dialog'),
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#4caf50",
          cancelButtonColor: "#ff5252",
          reverseButtons: false,
          cancelButtonText: this.$t('deny'),
          confirmButtonText: this.$t('confirm')
        })
        .then(result => {
          if (result.value) {
            axios.put(this.apiReject + '/' + this.dataForModal.id, this.form)
              .then(({data}) => {
                this.form = {
                  comment: ''
                }
                this.$refs.form.resetValidation()
                this.$emit('onReject', this.dataForModal)

              })
              .catch(error => {
                if (error.response.status === 401) {
                  this.$swal.fire({
                    type: 'info',
                    title: "Info",
                    text: this.$t('validation.session'),
                  })
                  this.$router.push('/login')
                } else {
                  this.$swal.fire({
                    type: 'error',
                    title: this.$t('validation.error'),
                    text: error.response.data.message,
                  })
                }
              });
          } else {
          }
        });
    }
  }
}
</script>

<style scoped/>
